import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { List, ListItem, ListItemAvatar, Typography, ListItemText, Divider, CircularProgress, Card, CardContent, CardHeader } from '@material-ui/core';
import { monthsTr } from 'src/utils/Common'

const useStyles = makeStyles(() => ({
  root: {},
  divider: {
    backgroundColor: '#FF9800'
  },
}));

const getAvatar = (dateStr) => {
  const date = new Date(dateStr);
  return [
    { id: 1, variant: "h3", text: date.getDate() },
    { id: 2, variant: "subtitle1", text: monthsTr[date.getMonth()] },
    { id: 3, variant: "subtitle1", text: date.getFullYear() },
    { id: 4, variant: "caption", text: date.toLocaleTimeString().substring(0, 5) }
  ]
}


function DigiportIssues({ issues, loading }) {

  const classes = useStyles();

  return (
    <Card>
      <CardHeader title={"Çağrılarım"} />
      <Divider />
      <CardContent className={classes.content}>
        <List className={classes.root}>
          {loading ? <CircularProgress
            status={'loading'}
            style={{ marginLeft: '50%' }}
          />
            :
            issues?.length > 0 && issues?.map(i => (
              <div key={i.id}>
                <ListItem alignItems="flex-start">
                  <ListItemAvatar>
                    <div>
                      {getAvatar(i.fields.created).map(a =>
                        <div key={a.id}>
                          <Typography
                            component="span"
                            variant={a.variant}
                            className={classes.inline}
                            color="textPrimary">
                            {a.text}
                          </Typography>
                          <br />
                        </div>
                      )}
                    </div>
                  </ListItemAvatar>
                  <ListItemText
                    primary={i?.key + ' - ' + (i?.fields?.customfield_11024?.requestType?.name || '')}
                    secondary={
                      <div>
                        Konu : {i.fields.summary}
                        <br />
                        Açıklama : {i.fields.description}
                        <br />
                        Durum: {i.fields.status.name}
                        <br />
                        İlgili Adı : {i.fields.assignee && i.fields.assignee.displayName}
                        <br />
                        İlgili Email : {i.fields.assignee && i.fields.assignee.emailAddress}
                        <br />
                        <a href={"https://digiport.arcelik.com/servicedesk/customer/portal/1/" + i.key}
                          target="_blank"
                          rel="noopener noreferrer">
                          Detaylar için tıklayınız
                        </a>
                      </div>
                    }
                  />
                </ListItem>
                <Divider className={classes.divider} />
              </div>
            ))}
        </List>
      </CardContent>
    </Card>
  );
}

export default DigiportIssues;
